import { render } from "./Baths.vue?vue&type=template&id=d014331e"
import script from "./Baths.vue?vue&type=script&lang=js"
export * from "./Baths.vue?vue&type=script&lang=js"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/sign-log/advertising-register/step/Baths.vue'],['render',render],['__file',"Baths.vue"]])

export default __exports__